function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .screenCasing {\n        fill: #c60e2d;\n      }\n\n      .screenFlorish {\n        fill: #0d1a99;\n        stroke: #329cfc;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "casing",
  className: "screenCasing",
  d: "M379,29.83H40a40.12,40.12,0,0,0-40,40V395.35H419V69.83A40.12,40.12,0,0,0,379,29.83Zm5.35,324.07H34.65V74.49h349.7Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "florish"
}, React.createElement("g", null, React.createElement("path", {
  className: "screenFlorish",
  d: "M218.64,52.79s-49,6.43-49.24-9.64S188.7,25.66,218.64,52.79Z"
}), React.createElement("path", {
  className: "screenFlorish",
  d: "M217.76,52.18S197.73,7,213.09,2.24,235.31,15.8,217.76,52.18Z"
}), React.createElement("path", {
  className: "screenFlorish",
  d: "M216.88,52.58s39.9-29.21,47.8-15.21S256.18,62,216.88,52.58Z"
})));

var SvgScreen = function SvgScreen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "screen",
    viewBox: "0 0 419 395.35",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/screen.23f3d52e.svg";
export { ForwardRef as ReactComponent };